/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IStackItemProps } from "@microsoft/shifts-ui-core";
import * as React from "react";
import StringsStore from "sh-strings/store";

import { getClassNames } from "./ScheduleGroupPeopleCountRow.styles";
import { ScheduleGroupPeopleCountRowProps } from "./ScheduleGroupPeopleCountRowProps";

/**
 * The people count cell properties.
 */
interface CellProps extends IStackItemProps {
    /**
     * The unique key identifier for the cell.
     */
    key: React.Key;
}

/**
 * Gets the list of each people count cell properties in order, from start date to end date.
 * @param props The 'ScheduleGroupPeopleCountRow' component properties.
 * @returns The list of each people count cell properties in order.
 */
export const getCellsProps = (props: ScheduleGroupPeopleCountRowProps): CellProps[] => {
    const { cellsTimestampsMs, peopleCountsByTimestampMs } = props;
    const cellProps: CellProps[] = [];
    const classNames = getClassNames();

    cellsTimestampsMs.forEach(timestampMs => {
        const count = timestampMs in peopleCountsByTimestampMs ? peopleCountsByTimestampMs[timestampMs].count : 0;

        cellProps.push({
            children: count,
            className: count == 0 ? classNames.cellZeroCount : undefined,
            key: `people-count-row-cell-${timestampMs}`
        });
    });

    return cellProps;
};

/**
 * Gets the translations strings.
 * @returns The translations strings.
 */
export const getTranslations = (): Map<string, string> => {
    return StringsStore().registeredStringModules.get("schedulePage").strings;
};
